import React, { useEffect, useState, useRef } from "react";

export default function DevOpsLoader(props) {
    const { showLoader } = props;

    return (
        <> {showLoader && (
            <div className="text-center py-5 loader">
                <div className="spinner-border text-primary"></div>
                <div className="mt-2 text-muted">Loading vehicle data...</div>
            </div>
        )}
        </>
    )
}